<template>
  <div>
    <div class="content">
      <div class="cont-list">
        <span class="list">{{
          this.parentRoute.menuName + "-" + this.route.menuName
        }}</span>
        <span class="masge">当前共有{{ total }}条资产流水</span>
      </div>
      <div class="header">
        <div class="left">
          <SelectFilter ref="selectFilter" :options="filterOptions" :query="query" @filterChange="filterChange" @reset="reset"></SelectFilter>
        </div>
        <div class="right">
          <div class="search">
            <el-input type="text" v-model="query.keyWord" @keyup.enter.native="queryChange">
              <i slot="suffix" class="el-icon-search" @click="queryChange"></i>
            </el-input>
            <!-- <i class="el-icon-search padding10" v-preventReClick @click="queryChange"></i> -->
          </div>
          <span v-preventReClick @click="reset" class="pointer">重置</span>
        </div>
      </div>

      <el-table ref="multipleTable" border :data="tableData" :max-height="tableHeight" style="width: 100%;" @selection-change="handleSelectionChange" stripe :header-cell-style="{ background: '#DDEBFF' }">
        <template slot="empty">
          <div class="empty-div" :style="{ height: tableHeight + 'px' }">
            <img src="../../../../assets/noData.png" width="240" height="240" />
            <span class="empty-span">抱歉！当前搜索状态下暂无相关数据，请核对后再查询！</span>
            <div class="empty-rest" @click="reset">恢复默认</div>
          </div>
        </template>
        <!-- <el-table-column align="center" type="selection" fixed width="55"> </el-table-column> -->
        <el-table-column prop="tableTypeName" label="流水类型" min-width="120"></el-table-column>
        <el-table-column prop="no" label="流水编号" min-width="180"></el-table-column>
        <el-table-column prop="no" label="资产名称" min-width="180">
          <template slot-scope="scope">
            <span>{{ scope.row.fixedAssetName }}</span><br />
            <span>{{ scope.row.fixedAssetNo }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="inOutTypeName" label="出入库类型" min-width="100"></el-table-column>
        <el-table-column prop="assetCardNo" label="资产卡号" min-width="150">
          <template slot-scope="scope">
            <el-tooltip effect="light" placement="bottom" popper-class="tooltip-content">
              <div slot="content" class="">
                <div class="tooltip-text" v-for="item in scope.row.assetCardInfos" :key="item.id">
                  {{ item.no }}
                </div>
              </div>
              <span class="td-overflow-hidden">{{
                scope.row.assetCardInfos
                  ? scope.row.assetCardInfos.map((e) => e.no).join(";")
                  : ""
              }}</span>
            </el-tooltip>
          </template>
        </el-table-column>
        <!-- <el-table-column prop="brandName" label="品牌" min-width="100"></el-table-column> -->
        <el-table-column prop="specName" label="规格型号" min-width="100"></el-table-column>
        <el-table-column prop="number" label="数量" min-width="80"></el-table-column>
        <el-table-column prop="price" label="单价" min-width="80"></el-table-column>
        <el-table-column prop="amount" label="总金额" min-width="100">
          <template slot-scope="scope">
            <span>￥{{ scope.row.amount }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="supplierName" label="供应商" min-width="100"></el-table-column>
        <el-table-column prop="manufacturerName" label="生产厂家" min-width="100"></el-table-column>
        <el-table-column prop="warehouseName" show-overflow-tooltip label="关联库房-货位" min-width="140">
          <template slot-scope="scope">
            <span>{{ scope.row.warehouseName
              }}{{
                scope.row.locationName ? "-" + scope.row.locationName : ""
              }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="certNo" label="注册证号" min-width="100"></el-table-column>
        <el-table-column prop="assetTypeName" label="资产类型" min-width="100"></el-table-column>
        <el-table-column prop="unitName" label="单位" min-width="100"></el-table-column>
        <el-table-column prop="packDesc" show-overflow-tooltip label="包装说明" min-width="100"></el-table-column>
        <el-table-column prop="createdUserName" label="创建人" min-width="120"></el-table-column>
        <el-table-column prop="createdTime" label="创建日期" min-width="100">
          <template slot-scope="scope">
            <div>{{ parseTime(new Date(scope.row.createdTime)) }}</div>
          </template>
        </el-table-column>
      </el-table>
      <div class="table-empty-text" v-show="tableData.length == 0">
        <div class="text-group">
          <div class="empty-text-group">
            <div class="empty-text-circle"></div>
            <span class="empty-text-label">
              抱歉！当前搜索状态下暂无相关数据，请核对后再查询！
            </span>
          </div>
          <div class="empty-text-btn" v-preventReClick @click="reset">
            恢复默认
          </div>
        </div>
      </div>
    </div>
    <div class="pagination">
      <el-pagination background layout="sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize" @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total" @current-change="changePage">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { GetInOutStockLogs } from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import SelectFilter from "@/components/table-select-filter";
import { InOutStockTypeOptions } from "@/enum";
import BaseListMixin from '@/mixin/baseList-mixin.js'

export default {
  mixins: [GetDataMixin, BaseListMixin],
  components: {
    // Info
    SelectFilter,
  },
  data () {
    return {
      GetDatasAction: GetInOutStockLogs,
      // PrintAction: GetAcceptInStockPrintData,
      // editPath: 'bad-event-edit',
      // // 查询条件
      // query: {
      //   keyWord: "",
      //   pageSize: 10,
      //   pageIndex: 1,
      // },
      // // 列表数据
      // tableData: [],
      // // 列表总数
      // total: 0,
      // // 弹出框标题
      // title: "",
      // // 弹出编辑框
      // open: false,
      // // 打开详情
      // showInfo: false,
      // id: 0,
      // // 新增、编辑的数据
      // form: {},
      // // 多选框数据
      // ids: [],
      // multipleSelection: [],
      // // 列表多选
      // multiple: true,
      filterOptions: [
        {
          name: "资产名称/规格",
          type: "select",
          code: "assetId",
          filterMethod: this.getFixedAssets,
          data: [],
        },
        {
          name: "库房",
          type: "select",
          code: "warehouseId",
          filterMethod: this.getWarehouses,
          data: [],
        },
        {
          name: "注册证号",
          type: "select",
          code: "certId",
          filterMethod: this.getProductRegistCerts,
          data: [],
        },
        {
          name: "出入库类型",
          type: "checkbox",
          code: "InOutType",
          options: InOutStockTypeOptions,
        },
        {
          name: "流水编号",
          type: "input",
          code: "no",
        },
        {
          name: "流水类型",
          type: "select",
          code: "tableType",
          filterMethod: this.getInOutTypeEnums,
          data: [],
        },
        {
          name: "资产类型",
          type: "selectTree",
          code: "assetTypeId",
          filterMethod: this.getFixedAssetTrees,
          data: [],
          defaultProps: {
            children: "children",
            label: "name",
          },
          text: "",
        },
        {
          name: "日期范围",
          type: "date",
          code: "date",
        },
      ],
    };
  },
  created () {
    // this.$nextTick(() => {
    // })
  },
  methods: {
    // handleSelectionChange (selection) {
    //   this.multipleSelection = selection;
    //   this.ids = selection.map((item) => item.id);
    //   this.multiple = !selection.length;
    // },
    // // 获取列表
    // getData () {
    //   GetInOutStockLogs(this.query).then((res) => {
    //     this.tableData = res.returnData.data;
    //     this.total = res.returnData.totalCount;
    //   });
    // },
    // // 改变当前页
    // changePage (val) {
    //   this.$set(this.query, "pageIndex", val);
    //   this.getData();
    // },
    // handleSizeChange (val) {
    //   this.$set(this.query, "pageSize", val);
    //   this.getData();
    // },
    // // 重置
    // reset () {
    //   this.query = {
    //     keyWord: "",
    //     pageSize: 10,
    //     pageIndex: 1,
    //   };
    //   if (this.$refs["selectFilter"]) {
    //     this.$refs["selectFilter"].resetQuery();
    //   }
    //   this.getData();
    // },
    // queryChange () {
    //   this.$set(this.query, "pageIndex", 1);
    //   this.getData();
    // },
    filterChange (query) {
      this.query = Object.assign(this.query, query);
      this.getData();
    },
  },
  mounted () {
    // this.getData();
  },
};
</script>

<style lang="scss" scoped>
.table-empty-text {
  width: 100%;
  height: calc(100% - 145px);
  line-height: 26px;
  display: flex;
  align-items: center;
  .text-group {
    width: 100%;
    text-align: center;
    .empty-text-group {
      display: flex;
      align-items: center;
      justify-content: center;
      .empty-text-circle {
        width: 60px;
        height: 60px;
        background: rgba(40, 106, 180, 0.5);
        border-radius: 50%;
        opacity: 1;
        margin-right: 20px;
      }
      .empty-text-label {
        font-size: 24px;
        font-weight: 400;
        line-height: 24px;
        color: #909399;
      }
    }
    .empty-text-btn {
      width: 100px;
      height: 26px;
      font-size: 20px;
      font-weight: 400;
      line-height: 24px;
      color: #286ab4;
      margin: auto;
      cursor: pointer;
      border-bottom: 1px solid #286ab4;
    }
  }
}
/deep/.el-table__empty-block {
  height: 0;
  min-height: 0;
}
</style>
